import React from 'react';
import { Spinner } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useHistory } from 'react-router-dom';

import { ReactComponent as SuccessIcon } from '../../assets/Images/success_icon.svg';

// eslint-disable-next-line import/prefer-default-export
export const SuccessModal = ({ message, showSuccess, setShowSuccess, redirect }) => {
  const history = useHistory();
  return (
    <Modal
      size="md"
      show={showSuccess}
      onHide={() => setShowSuccess(false)}
      centered
      aria-labelledby="example-modal-sizes-title-sm">
      <Modal.Body>
        <div className="d-flex flex-column justify-content-center align-items-center p-4">
          <SuccessIcon />
          <div className="mt-4 fs-5 text-center fw-bold">Yaay!! {message}.</div>
          <Button
            className="mt-5 staff_modals_form_button"
            variant="primary"
            onClick={() => {
              setShowSuccess(false);
              if (redirect) {
                history.push(redirect);
              }
            }}>
            Okay
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

// eslint-disable-next-line import/prefer-default-export
export const PromptModal = ({
  title,
  message,
  showPrompt,
  handlePromptClose,
  promptActionHandler,
  loading
}) => {
  return (
    <Modal size="md" centered show={showPrompt} onHide={handlePromptClose} animation>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}?</Modal.Body>
      <Modal.Footer className="d-flex justify-content-center">
        <Button
          className="me-3 staff_modal_update_no"
          variant="outline-primary"
          onClick={handlePromptClose}>
          No
        </Button>
        {loading ? (
          <div className="">
            <Spinner className="spinner" animation="border" variant="dark" />
          </div>
        ) : (
          <Button
            variant="primary"
            className="me-3 staff_modal_update_yes"
            onClick={promptActionHandler}>
            Yes
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};
